/**
 * 业务整段朗读 API 开关（测完改回 'tts1' 即可；口语广场 tts_ticket 不受影响）
 * - 'tts1'：Cibei 优先，Azure 兜底
 * - 'tts3'：Edge TTS 优先，Azure 兜底（form-urlencoded；不支持 phoneme）
 */
export const COURSE_TTS_API = 'tts3'

/**
 * 口语广场流式 TTS 通道一键开关
 *
 * - `true`：Edge WS（`tts_ws_ticket` → `WS /ws/audio/speech`）；失败由页面 toast，**不**降级 HTTP
 * - `false`：回旧 Kokoro 流式（`tts_ticket` → `ttsStreamSession`）
 *
 * 与 `COURSE_TTS_API`（游戏/查词 HTTP）无关。发现问题改成 `false` 即可一键切回。
 */
export const SPEAKING_PLAZA_USE_EDGE_TTS_WS = true

/**
 * 发音语速自定义已全员开放（设置页滑条 + 持久化 speaker_speed）。
 * 默认语速 tts3=-10；该档 OSS 已全量预跑，命中时几乎无需等待合成。
 *
 * @deprecated 保留兼容旧引用；始终返回 true
 */
export function canCustomizeTtsSpeed (_userId) {
  return true
}
